import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { U2bApiService } from './u2b-api.service';
import { HttpClient } from '@angular/common/http';
import { IFile } from '@shared/interfaces/file';

@Injectable({ providedIn: 'root' })
export class U2bFilesApiService extends U2bApiService {

    private readonly RESOURCE_ENDPOINT = 'files';

    protected constructor(_http: HttpClient) {
        super(_http);
    }

    getById(id: number, params: HttpParams = new HttpParams(), options?: { suppressErrors?: boolean }): Observable<Blob> {
        if (options?.suppressErrors) {
            this._suppressErrorForNextRequest = true;
        }
        return super.getBlob(`${this.RESOURCE_ENDPOINT}/${id}`, params);
    }

    upload(file: File, params: HttpParams = new HttpParams()): Observable<IFile> {
        const formData = new FormData();
        formData.append('file', file, file.name);
        return super.post<IFile>(this.RESOURCE_ENDPOINT, formData, params);
    }
}
